import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';

export default function() {
  tippy('a[title]', {
    content(reference) {
      const title = reference.getAttribute('title');
      reference.removeAttribute('title');
      return title;
    },
  });

  tippy('[data-tippy-content]');
}
